import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { defaultTheme } from '../../../components/core/Button/buttonTheme';
import SkipifyLogo from './small_skipify_logo.svg';
import palette from '../../../styles/themes/palette';

const ButtonLogoPreview = ({ logo }: { logo?: string | File | undefined | null }) => {
  const theme = defaultTheme.primary;
  const sxProps = {
    cursor: 'pointer',
    display: 'flex',
    background: theme.backgroundColor,
    height: '56px',
    minWidth: '150px',
    borderRadius: '12px',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
    gap: '10px',
    '&:hover': {
      backgroundColor: theme.hover.backgroundColor,
    },
  };
  return (
    <Box
      sx={{
        width: { md: '312px', xs: '100%' },
        maxWidth: '312px',
        height: '261px',
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: '24px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'secondary.light',
        px: 2,
        pt: 2,
      }}
    >
      <Stack spacing={8} sx={{ height: '100%' }}>
        <Typography variant="medium" fontWeight="bold">
          Preview
        </Typography>
        <Button
          variant="outlined"
          disableRipple
          fullWidth
          data-testid="button-logo-preview"
          aria-label="Button Logo Preview"
          sx={sxProps}
        >
          <img src={SkipifyLogo} data-testid="muted-logo" alt="Muted Logo" />
          <Typography variant="large" fontWeight="semibold" color="background.default">
            Buy Now
          </Typography>
          {logo && <span style={{ color: palette.background.default, fontSize: '16px' }}>|</span>}
          {logo ? (
            <img
              data-testid="button-logo-merchant"
              style={{ maxWidth: '70px', maxHeight: '18px' }}
              src={typeof logo === 'string' ? logo : URL.createObjectURL(logo)}
              alt="ButtonLogo"
            />
          ) : undefined}
        </Button>
      </Stack>
    </Box>
  );
};

export default ButtonLogoPreview;
